import * as React from 'react'

import { observer } from 'mobx-react'

import SelectField from 'modules/core/components/SelectField'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import type Taxonomy from 'modules/contracts/store/models/Taxonomy'
import ExpensesCategoryContractsTaxonomy from 'modules/payroll_bundle/store/models/ExpensesCategoryContractsTaxonomy'

const ExpenseMappingDropdown = ({
  taxonomies,
  mapping,
}: {
  taxonomies: Taxonomy[]
  mapping: ExpensesCategoryContractsTaxonomy
}) => {
  const { performAction } = useAsyncAction((contractsTaxonomyId: string) => {
    const data = mapping.id
      ? mapping.update({ contracts_taxonomy_id: contractsTaxonomyId })
      : ExpensesCategoryContractsTaxonomy.create({
          ...mapping.toJS(),
          contracts_taxonomy_id: contractsTaxonomyId,
        }).then((m) => mapping.set(m.toJS()))
    track(trackingEvents.payroll.selectSupplementTitle)
    return data
  })

  const options = taxonomies.map((taxonomy) => ({
    label: taxonomy.attributes.name,
    value: taxonomy.id,
  }))

  const selectedValue = mapping.attributes.contracts_taxonomy_id

  return (
    <SelectField
      options={options}
      mandatory
      none={!selectedValue ? i18n.t('common.none') : undefined}
      onChange={performAction}
      value={selectedValue}
    />
  )
}

export default observer(ExpenseMappingDropdown)
